import { useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Icon,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Input,
  DrawerFooter,
  useDisclosure,
  Text,
} from "@chakra-ui/react";
import Countdown from "./Countdown";
import {
  SettingIcon,
  RefreshIcon,
  PlayIcon,
  PauseIcon,
  SpeakerIcon,
} from "./icons";
import { useRecoilState, useSetRecoilState } from "recoil";
import * as state from "../state";
import Button from "./Button";

const Settings = ({ isOpen, onClose, buttonRef }: any) => {
  const [refreshTime, setRefreshTime] = useRecoilState(state.refreshTime);
  const [updateTime, setUpdateTime] = useRecoilState<any>(
    state.refreshUpdateTime
  );
  const onChangeInput = (e: any) => {
    setTimeout(() => {
      setRefreshTime(e.target.value);
      setUpdateTime(new Date());
    }, 1000);
  };
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      finalFocusRef={buttonRef}
      // size="sm"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />

        <DrawerHeader>Settings</DrawerHeader>

        <DrawerBody>
          <Flex flexDirection="column" gap="3">
            <Input
              onChange={onChangeInput}
              type="number"
              placeholder="Refresh time"
            />
            <Text
              color="blue.700"
              fontWeight="bold"
              textAlign="right"
              fontSize="sm"
            >
              {updateTime !== null && (
                <Box
                  display="flex"
                  gap="1"
                  justifyContent="flex-end"
                  alignItems="baseline"
                >
                  <Text fontSize="xs">Updated on </Text>{" "}
                  {new Date().toLocaleDateString("tr", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                  })}
                </Box>
              )}
            </Text>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

const Header = () => {
  const [isPause, toggleStartStop] = useRecoilState(state.isPause);
  const togglePlaying = () => toggleStartStop(!isPause);
  useEffect(() => {}, [isPause]);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const optionsButtonRef = useRef();

  return (
    <Box
      minW="full"
      display="flex"
      justifyContent="center"
      padding="3"
      textAlign="right"
    >
      <Flex justifyContent="space-between" alignItems="center" width="100vw">
        <Box width="20" textAlign="start">
          <Countdown />
        </Box>
        <Box display="flex" gap="2">
          <Button
            background={isPause ? "green.600" : "red.600"}
            onClick={togglePlaying}
          >
            {isPause ? <Icon as={PlayIcon} /> : <Icon as={PauseIcon} />}
          </Button>
          <Button
            isDisabled
            background="blackAlpha.300"
            onClick={togglePlaying}
          >
            <Icon as={RefreshIcon} />
          </Button>
          <Button isDisabled background="blue.600">
            <Icon as={SpeakerIcon} />
          </Button>
        </Box>
        <Box display="flex" alignItems="normal" gap="1" p="2">
          <Button ref={optionsButtonRef} onClick={onOpen}>
            <Icon as={SettingIcon} />
          </Button>
          <Settings
            isOpen={isOpen}
            onClose={onClose}
            buttonRef={optionsButtonRef}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default Header;
